
/**
 * Export `downloadPdfFile`.
 */

export function downloadPdfFile(data, filename: string) {
  if (!(data instanceof Blob)) {
    return;
  }

  const blob = new Blob([data], { type: 'application/pdf' });
  const link = document.createElement('a');

  link.href = window.URL.createObjectURL(blob);
  link.download = `${filename}-${+new Date()}.pdf`;
  link.click();
}

/**
 * Export `downloadFileFromUrl`.
 *
 * Goes through `/api/download`, which answers with `Content-Disposition:
 * attachment`: the files bucket has no CORS headers, so the browser cannot
 * fetch the file itself, and a cross-origin `<a download>` is ignored.
 */

export function downloadFileFromUrl(url: string) {
  const link = document.createElement('a');

  link.href = `/api/download?url=${encodeURIComponent(url)}`;
  link.click();
}
